import { Page } from '@app/components/page/Page';
import { AdminModule } from '@app/modules/admin';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import compact from 'lodash/compact';
import { useIntl } from 'react-intl';

interface Props {
  platform?: SocialPlatform;
}

export function SocialExportBreadcrumbs({ platform }: Props) {
  const { $t } = useIntl();

  const items = compact(
    platform
      ? [
          {
            content: $t(
              {
                id: 'admin.socialExport.title',
                defaultMessage: 'Integración con {name}',
              },
              { name: platform.name },
            ),
            href: `/admin/social-export/${platform.id.toLowerCase()}`,
          },
        ]
      : [],
  );

  return <Page.ModuleBreadcrumbs module={AdminModule} items={items} />;
}
